(function($){

	$(document).ready(function(){

		$('.articles-centered-slider').each(function(index){
	
			if(!$(this).hasClass('slick-initialized')) {

				$(this).slick({
			        slidesToShow: 1,
			        slidesToScroll: 1,
			        arrows: true,
			        dots: true,
			        infinite: true,
			        fade: true,
			        prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.57113 12.431H22V11.569H3.57113L12.4459 2.60345L11.8514 2L2 12L11.8514 22L12.4459 21.3966L3.57113 12.431Z" fill="#E9331A"/></svg></button>',
			        nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M20.4289 11.569L2 11.569V12.431L20.4289 12.431L11.5541 21.3966L12.1486 22L22 12L12.1486 2L11.5541 2.60345L20.4289 11.569Z" fill="#E9331A"/></svg></button>'
			    });  
			}
		});

	});
	
})(jQuery);